/*
  Product recommendations loader.

  Fetches the server-rendered recommendations markup from Shopify's Product
  Recommendations route (data-url on [data-product-recommendations]), swaps it
  into the live container, then mounts the shared ProductsSlider on it so the
  carousel behaves identically to the Best Sellers slider.

  The fetched HTML is this theme's own section render (same-origin), so nodes
  are moved in via importNode — no innerHTML assignment, no external/API data.
*/
if (!window.DigitalizModules) window.DigitalizModules = {};

if (!window.DigitalizModules.ProductRecommendations) {
  class ProductRecommendations {
    constructor(root) {
      this.root = root; // [data-product-recommendations]
      this.url = root.dataset.url;
      this.slider = null;
      this._load();
    }

    _load() {
      if (!this.url) return;

      fetch(this.url)
        .then((res) => {
          if (!res.ok) throw new Error('Recommendations request failed: ' + res.status);
          return res.text();
        })
        .then((text) => {
          const doc = new DOMParser().parseFromString(text, 'text/html');
          const fetched = doc.querySelector('[data-product-recommendations]');
          if (!fetched || !fetched.hasChildNodes()) return;

          while (this.root.firstChild) {
            this.root.removeChild(this.root.firstChild);
          }
          Array.from(fetched.childNodes).forEach((node) => {
            this.root.appendChild(document.importNode(node, true));
          });

          this._initCards();
          this._mountSlider();
        })
        .catch(() => {
          // Recommendations are a progressive enhancement — fail silently.
        });
    }

    _initCards() {
      const Card = window.DigitalizModules && window.DigitalizModules.ProductCard;
      if (Card && typeof Card.initWithin === 'function') {
        Card.initWithin(this.root);
      }
    }

    _mountSlider() {
      const Slider = window.DigitalizModules && window.DigitalizModules.ProductsSlider;
      if (!Slider) return;
      if (!this.root.querySelector('[data-psl-slider]')) return;
      this.slider = new Slider(this.root);
    }

    destroy() {
      if (this.slider && typeof this.slider.destroy === 'function') {
        this.slider.destroy();
      }
      this.slider = null;
    }
  }

  window.DigitalizModules.ProductRecommendations = ProductRecommendations;

  function init(root) {
    root.querySelectorAll('[data-product-recommendations]').forEach((el) => {
      if (el.dataset.prInit) return;
      el.dataset.prInit = '1';
      new ProductRecommendations(el);
    });
  }

  init(document);

  // Re-run when the Theme Editor adds or re-renders the section.
  document.addEventListener('shopify:section:load', (event) => {
    init(event.target);
  });
}
